export default {
  title: "Catalogue",
  chooserLead:
    "An authoritative catalogue of persons, works, editions and prizes. Search with facets or select by criteria.",
  modeSearch: "Catalogue search",
  modeQuery: "Select by criteria",
  modeSearchHint: "Free text, facets, sorting",
  modeQueryHint: "Scenarios: author, publisher, prize…",
  openSearch: "Open search",
  openQuery: "Open selection",
  quickSearchPlaceholder: "Author, title, ISBN…",
  quickSearchSubmit: "Search",
  switchToQuery: "Need precise criteria? →",
  switchToSearch: "Prefer a keyword search? →",
  modeTabsAria: "Catalogue mode",
  viewAria: "Catalogue view",
  viewSimple: "Simple",
  viewExpert: "Full",
}
